export default __webpack_public_path__ + "static/media/5.4cd1eb6a.mp3";